// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1iYeR","description":"PatientConsentPreview_description__IxNPb"};